import { Col, Container, Row } from "react-bootstrap";
import { LatestJobs } from "@/components/LatestJobs";
import { AskExpertsAside } from "@/components/AskExpertsAside";
import clsx from "classnames";
import styles from "./styles.module.scss";

export const Text = ({
  className,
  content,
  showLatestJobs,
  showAskExperts,
}) => {
  return (
    <div className={clsx(className, styles.text)}>
      <Container fluid="lg" className="py-5 py-md-6">
        <Row>
          <Col xs={12} md={9}>
            {content && (
              <div
                data-sourceflow-prop="content"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </Col>
          <Col xs={12} md={3}>
            {showLatestJobs && <LatestJobs className="mb-4" limit={1} />}
            {showAskExperts && <AskExpertsAside />}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Text;
